var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsDate, IsInt, IsUUID, Min } from 'class-validator';
/**
 * An appointment already placed in the planning, sent with
 * {@link FindEarliestSlotsRequestDto.fixedSlots} so the slot finder proposes
 * only the rest around it (#1937; the single `anchor` of PRD #944 before it):
 * the step-1 appointment, or an entry the scheduler changed by hand. Each
 * fixed slot:
 *
 * - counts as one placed unit of its treatment (the matching constraint's
 *   `appointmentCount` and the request's `n` go down by one) — a slot for a
 *   treatment not being searched counts for nothing;
 * - blocks its therapist's time;
 * - blocks the patient's time for every therapist, so nothing is proposed on
 *   top of it;
 * - counts towards its treatment's week of the weekly frequency.
 *
 * It is a virtual placement at search time and is not echoed back: the caller
 * already holds it.
 */
export class FixedSlotDto {
    treatmentId;
    start;
    end;
    therapistId;
    /** Duration in minutes — informational; the busy interval is `start`–`end`. */
    duration;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], FixedSlotDto.prototype, "treatmentId", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], FixedSlotDto.prototype, "start", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], FixedSlotDto.prototype, "end", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], FixedSlotDto.prototype, "therapistId", void 0);
__decorate([
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], FixedSlotDto.prototype, "duration", void 0);
//# sourceMappingURL=fixed-slot.dto.js.map